export class PagerData {
    public page: number;
    public pagerSize: number;
}
